import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=71121d99&scoped=true&"
import script from "./ProjectSettings.vue?vue&type=script&lang=ts&"
export * from "./ProjectSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSettings.vue?vue&type=style&index=0&id=71121d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71121d99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VChip,VCol,VProgressCircular,VRow,VSimpleTable,VTextField})
